import { i18n } from "@lingui/core";
import  amMessages  from "./am.json";
import  ruMessages  from "./ru.json";
import  enMessages  from "./en.json";

const lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : 'am';

i18n.load("en", enMessages);
i18n.load("ru", ruMessages);
i18n.load("am", amMessages);
i18n.activate(lang);

export default i18n;
